export interface Company {
  id?: string;
  email?: string;
  companyName?: string;
  contactPersonName?: string;
  website?: string;
  phone?: string;
  address?: CompanyAddress;
  categoryIds?: string[];
  acceptedPrivacyPolicy?: boolean;
  acceptedAgb?: boolean;
  uid?: string;
  status?: CompanyInvitationStatus;
}

export interface CompanyInvitation {
  email: string;
}

export enum CompanyInvitationStatus {
  PENDING = 'PENDING',
  ACCEPTED = 'ACCEPTED',
  CREATED_NO_EMAIL = 'CREATED_NO_EMAIL',
}

export interface CompanyAddress {
  streetAndNumber: string;
  city: string;
  postalCode: string;
}

export class CompanyUser {
  id?: string;
  email?: string;
  status?: string;
  companyName?: string;
  contactPersonName?: string;
  website?: string;
  phone?: string;
  address?: CompanyAddress;
  categoryIds?: string[];
  acceptedPrivacyPolicy?: boolean;
  acceptedAgb?: boolean;
  uid?: string;
  password = '';

  constructor(data: CompanyUser) {
    this.id = data.id;
    this.email = data.email;
    this.status = data.status;
    this.companyName = data.companyName;
    this.contactPersonName = data.contactPersonName;
    this.password = data.password;
    this.website = data.website;
    this.phone = data.phone;
    this.address = data.address;
    this.categoryIds = data.categoryIds;
    this.acceptedPrivacyPolicy = data.acceptedPrivacyPolicy;
    this.acceptedAgb = data.acceptedAgb;
    this.uid = data.uid;
  }

  static fromJson(json: string): CompanyUser {
    const data = JSON.parse(json);
    return new CompanyUser(data);
  }
}
